module.exports = __webpack_public_path__ + "img/av-mobile-default.53fbd84b.png";